import React from 'react';
import { Col } from 'bootstrap-4-react';
import santiago from "../../images/santiago.png";

class SmallTeam extends React.Component{
    render() {
       return (
            <Col col="sm-3 lg-2 6" className="team-small">
                <div className="img-container">
                    <img src={"https://backendtest.moobifun.com" + this.props.picture}/>
                </div>
                <div className="team-details">
                    <h4>{this.props.name}</h4>
                    <span>{this.props.position}</span>
                </div>
            </Col>
       );
    }
}
export default SmallTeam;
